"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetSortFieldToJSON = exports.AdSetSortFieldFromJSONTyped = exports.AdSetSortFieldFromJSON = exports.AdSetSortField = void 0;
/**
 * Field by which to sort list of adsets.
 * @export
 */
exports.AdSetSortField = {
    CreatedAt: 'CREATED_AT',
    UpdatedAt: 'UPDATED_AT',
    Name: 'NAME',
    Status: 'STATUS',
    Budget: 'BUDGET',
    StartDateTime: 'START_DATE_TIME',
    EndDateTime: 'END_DATE_TIME'
};
function AdSetSortFieldFromJSON(json) {
    return AdSetSortFieldFromJSONTyped(json, false);
}
exports.AdSetSortFieldFromJSON = AdSetSortFieldFromJSON;
function AdSetSortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdSetSortFieldFromJSONTyped = AdSetSortFieldFromJSONTyped;
function AdSetSortFieldToJSON(value) {
    return value;
}
exports.AdSetSortFieldToJSON = AdSetSortFieldToJSON;
